import Wkt from 'wicket'
export const gridsetName = 'EPSG:4326'

export const gridNames = [
  'EPSG:4326:0',
  'EPSG:4326:1',
  'EPSG:4326:2',
  'EPSG:4326:3',
  'EPSG:4326:4',
  'EPSG:4326:5',
  'EPSG:4326:6',
  'EPSG:4326:7',
  'EPSG:4326:8',
  'EPSG:4326:9',
  'EPSG:4326:10',
  'EPSG:4326:11',
  'EPSG:4326:12',
  'EPSG:4326:13',
  'EPSG:4326:14',
  'EPSG:4326:15',
  'EPSG:4326:16',
  'EPSG:4326:17',
  'EPSG:4326:18'
]

export const remoteBaseUrl = '//api.novaecs.com/nova_service/geoserver/'

export const remoteFormat = 'image/png'

export const districtOrder = [
  { title: '东港区', order: 1 },
  { title: '岚山区', order: 2 },
  { title: '五莲县', order: 3 },
  { title: '莒县', order: 4 },
]

// 裸土管理界面 区县列表
export const districts = [
  '小店区', '迎泽区', '杏花岭区', '尖草坪区', '万柏林区',
  '晋源区', '清徐县', '阳曲县', '娄烦县', '古交市'
]

export const quarterOptions = [
  { title: '第一季度', value: 1 },
  { title: '第二季度', value: 2 },
  { title: '第三季度', value: 3 },
  { title: '第四季度', value: 4 }
]


// 裸土管理界面 裸土状态
export const bareSoilStatus = [
  '新增',
  '扩增',
  '整改完成',
  '覆盖不完全',
  '留存',
  '其他',
  '办结'
]


// 级联过滤方法
export function filter (inputValue, path) {
  return path.some(option => option.name.toLowerCase().indexOf(inputValue.toLowerCase()) > -1)
}

// wkt multipolyline转为字符串
export function wktToStr (data) {
  let str = ''
  if (data && data.startsWith('MULTI')) {
    // wkt转为point
    const wkt = new Wkt.Wkt()
    const lines = wkt.read(data).components
    if (lines && lines.length) {
      for (let l = 0; l < lines.length; l++) {
        const points = lines[l]
        let lineStr = ''
        if (points && points.length) {
          for (let i = 0; i < points.length; i++) {
            if (i === points.length - 1) {
              lineStr += `${points[i].x},${points[i].y}`
            } else {
              lineStr += `${points[i].x},${points[i].y}\n`
            }
          }
        }
        if (l === lines.length - 1) {
          str += lineStr
        } else {
          str += lineStr + '\n\n'
        }
      }
    }
  }
  return str
}
// 字符串转wkt
export function strToWkt (data) {
  let str = ''
  if (data) {
    const coordinates = data.split('\n\n').map(line => {
      return line.split('\n').map(item => {
        return item.split(',')
      })
    })
    str = pointToWkt(coordinates)
  }
  return str
}

// 字符串转wkt
export function strToWkt2 (data) {
  let str = ''
  if (data) {
    const coordinates = data.split('|').map(line => {
        // return line.split(',')
        return line.split(';').map(item => {
        return item.split(',')
      })
    })
    str = pointToWkt(coordinates)
  }
  return str
}

// wkt转point
export function wktToPoint (data) {
  let points = []
  if (data && data !== 'null' && data.startsWith('POLYGON')) {
    const wkt = new Wkt.Wkt()
    points = wkt.read(data).components
  }
  return points
}

// wkt转为geojson
export function wktToGeo (data) {
  let points = []
  if (data && data !== 'null' && (data.startsWith('POLYGON') || data.startsWith('MULTI') || data.startsWith('Multi'))) {
    const wkt = new Wkt.Wkt()
    points = wkt.read(data).toJson()
  }
  return points
}

// geojson转为wkt
export function geoToWkt (geometry) {
  let str = ''
  if (geometry) {
    const wkt = new Wkt.Wkt()
    wkt.fromObject(geometry)
    str = wkt.write()
  }
  return str
}

// multiline的point转为wkt
export function pointToWkt (coordinates) {
  let str = ''
  if (coordinates && coordinates.length) {
    const wkt = new Wkt.Wkt()
    wkt.fromObject({ 'coordinates': coordinates, 'type': 'MultiLineString' })
    // wkt.fromObject({ 'coordinates': coordinates, 'type': 'MULTIPOLYGON' })

    str = wkt.write()
  }
  return str
}

// multipolygon转为字符串
export function multipolygonwktToStr (data) {
  let str = ''
  if (data && data.startsWith('MULTI')) {
    // wkt转为point
    const wkt = new Wkt.Wkt()
    const multipolygon = wkt.read(data).components
    if (multipolygon && multipolygon.length) {
      for (let l = 0; l < multipolygon.length; l++) {
        const polygons = multipolygon[l]
        let polygonsStr = ''
        if (polygons && polygons.length) {
          for (let i = 0; i < polygons.length; i++) {
            const polygon = polygons[i]
            let polygonStr = ''
            for (let j = 0; j < polygon.length; j++) {
              if (j === polygon.length - 1) {
                polygonStr += `${polygon[j].x},${polygon[j].y}`
              } else {
                polygonStr += `${polygon[j].x},${polygon[j].y}\n`
              }
            }
            if (i === polygons.length - 1) {
              polygonsStr += polygonStr
            } else {
              polygonsStr += `${polygonStr}\n\n`
            }
          }
        }
        if (l === multipolygon.length - 1) {
          str += polygonsStr
        } else {
          str += polygonsStr + '\n\n\n'
        }
      }
    }
  }
  return str
}

// 区域字符串转wkt
export function strTomultipolygonwkt (data) {
  let str = ''
  if (data) {
    const coordinates = data.split('\n\n\n').map(polygons => {
      return polygons.split('\n\n').map(polygon => {
        return polygon.split('\n').map(item => {
          return item.split(',')
        })
      })
    })
    if (coordinates && coordinates.length) {
      const wkt = new Wkt.Wkt()
      wkt.fromObject({ 'coordinates': coordinates, 'type': 'MultiPolygon' })
      str = wkt.write()
    }
  }
  return str
}

// 计算区域中心点坐标
export function getPloygonCenter (data) {
  let lng = 0
  let lat = 0
  let count = 0
  if (data) {
    const coordinates = data.split('\n\n\n').map(polygons => {
      return polygons.split('\n\n').map(polygon => {
        return polygon.split('\n').map(item => {
          return item.split(',')
        })
      })
    })
    if (coordinates.length) {
      for (let i = 0; i < coordinates.length; i++) {
        const polys = coordinates[i]
        if (polys.length) {
          for (let j = 0; j < polys.length; j++) {
            const poly = polys[j]
            if (poly.length) {
              for (let p = 0; p < poly.length; p++) {
                lng += Number(poly[p][0])
                lat += Number(poly[p][1])
                count = count + 1
              }
            }
          }
        }
      }
      lng = lng / count
      lat = lat / count
    }
  }
  return { lng, lat }
}
export function getSinglePolygonCenter (points) {
  let x = 0.0
  let y = 0.0
  if (points && points.length) {
    for (const point of points) {
      x = x + parseFloat(point.lng)
      y = y + parseFloat(point.lat)
    }
    x = x / points.length
    y = y / points.length
  }
  const point = new BMap.Point(x, y)
  return point
}

/**
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 */
 export function difference (object, base) {
  function changes (object, base) {
      return _.transform(object, function (result, value, key) {
          if (!_.isEqual(value, base[key])) {
              result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value
          }
      })
  }
  return changes(object, base)
}

// 遍历树形数据
export function traverseTreeData (data) {
  if (data.length) {
    for (let i = 0; i < data.length; i++) {
      data[i].scopedSlots = { title: 'name' }
      // 已经绑定（存在packageId和regionId）的区域禁止点击
      const { packageId, regionId } = data[i]
      if (packageId && regionId) {
        data[i].disabled = true
      }
      if (data[i].children.length) {
        traverseTreeData(data[i].children)
      }
    }
  }
}

// 计算字符串长度
/**
 * 获取输入内容的长度
 * @param value
 * @return 内容的长度
 */
export const getInputSize = (value) => {
  if (!value) {
    return 0
  }
  const charCount = value.split('').reduce((prev, curr) => {
    // 英文字母和数字等算一个字符；这个暂时还不完善；
    if (/[a-z]|[0-9]|[,;.!@#-+/\\$%^*()<>?:"'{}~]/i.test(curr)) {
      return prev + 1
    }
    // 其他的算是2个字符
    return prev + 2
  }, 0)

  // 向上取整，防止出现半个字的情况
  return Math.ceil(charCount / 2)
}

export function transformDistanceToPixel (map, distance) {
  if (!map) { return }
   const origin = map.getCenter()
   // 中心点坐标
   const point = new BMap.Point(origin.lng, origin.lat)
   const center = map.pointToPixel(point)
   // 半径
   const turfPoint = turf.point([origin.lng, origin.lat])
   const bearing = 90
   const options = { units: 'kilometers' }
   const destinationPoint = turf.destination(
     turfPoint,
     distance / 1000,
     bearing,
     options
   )
   const coordinates = destinationPoint.geometry.coordinates
   const destination = new BMap.Point(coordinates[0], coordinates[1])
   const dCenter = map.pointToPixel(destination)
   const pixel = Math.abs(center.x - dCenter.x)
   return pixel
}

class Enum {
  #valKeyMap = {}

  constructor(initObj) {
    Object.entries(initObj).forEach(([key, value]) => {
      this[key] = value
    })
    this.#valKeyMap = Object.entries(initObj).reduce((acc, [key, value]) => {
      acc[value] = key
      return acc
    }, {})
  }

  keyByVal(v) {
    return this.#valKeyMap[v]
  }
}

export const YGCRSTypes = new Enum({
  WGS84: 'EPSG:4326',
  BD09: 'BD:09',
})
